var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.16994C10.8126 0.983692 10.5592 0.87915 10.295 0.87915C10.0308 0.87915 9.77736 0.983692 9.58999 1.16994L5.99999 4.70994L2.45999 1.16994C2.27263 0.983692 2.01918 0.87915 1.75499 0.87915C1.49081 0.87915 1.23736 0.983692 1.04999 1.16994C0.956266 1.26291 0.881872 1.37351 0.831103 1.49537C0.780334 1.61723 0.754196 1.74793 0.754196 1.87994C0.754196 2.01195 0.780334 2.14266 0.831103 2.26452C0.881872 2.38638 0.956266 2.49698 1.04999 2.58994L5.28999 6.82994C5.38296 6.92367 5.49356 6.99806 5.61542 7.04883C5.73728 7.0996 5.86798 7.12574 5.99999 7.12574C6.13201 7.12574 6.26271 7.0996 6.38457 7.04883C6.50643 6.99806 6.61703 6.92367 6.70999 6.82994L11 2.58994C11.0937 2.49698 11.1681 2.38638 11.2189 2.26452C11.2697 2.14266 11.2958 2.01195 11.2958 1.87994C11.2958 1.74793 11.2697 1.61723 11.2189 1.49537C11.1681 1.37351 11.0937 1.26291 11 1.16994Z",
    fill: "#239EC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.3cb912410a54386daf18768950d666a9.svg";
export { ForwardRef as ReactComponent };